import { render, staticRenderFns } from "./Periodicalcheck.vue?vue&type=template&id=276043fc&scoped=true&"
import script from "./Periodicalcheck.vue?vue&type=script&lang=js&"
export * from "./Periodicalcheck.vue?vue&type=script&lang=js&"
import style0 from "./Periodicalcheck.vue?vue&type=style&index=0&id=276043fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276043fc",
  null
  
)

export default component.exports